import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { RadioGroup, FormControlLabel, Radio, FormControl } from "@mui/material";
import BMXButton from "../../../../../../Components/Buttons/BMXButton/BMXButton";
import CanvasDraw from "react-canvas-draw";
import moment from "moment";
import { useEffect } from "react";

const ServiceConfirmFormStepOne = (props) => {
  const { t } = useTranslation();


  const { values, form, canvasDrawRef, isSubmit,submitFailed } = props;

  useEffect(() => {
    if (Boolean(values?.signature)) {
      canvasDrawRef.current.loadSaveData(values?.signature)
    }
  }, [values?.signature])

  const generateTime = () => {
    form.change('dateAndTimeOfService', new Date());
  }

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row className="mt-4">
        <Col className="d-flex align-items-center justify-content-end" xs={6} >
          <small>{t('global:serviceconfirmmodal.donecorrectly')}:</small>
        </Col>
        <Col className="d-flex align-items-center justify-content-start" xs={{ span: 5, offset: 1 }} >
          <Field
            name="doneCorrectly"
          >
            {options => <FormControl>
              <RadioGroup
                row
                {...options.input}
              >
                <FormControlLabel disabled={Boolean(values?.signature)} value="true" control={<Radio sx={{
                  '&.Mui-checked': {
                    color: 'var(--BMX-primary)',
                  },
                }} />} label={t('global:yes')} />
                <FormControlLabel disabled={Boolean(values?.signature)} value="false" control={<Radio sx={{
                  '&.Mui-checked': {
                    color: 'var(--BMX-primary)',
                  },
                }} />} label={t('global:no')} />
              </RadioGroup>
            </FormControl>}
          </Field>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="d-flex align-items-center justify-content-end" xs={6} >
          <small>{t('global:serviceconfirmmodal.dateandtimeofservice')}:</small>
        </Col>
        <Col className="d-flex align-items-center justify-content-start" xs={{ span: 5, offset: 1 }} >
          <BMXButton disabled={Boolean(values?.dateAndTimeOfService)} onClick={() => generateTime()} bmxclass="Success ">{Boolean(values?.dateAndTimeOfService) ? moment(values?.dateAndTimeOfService).format("DD/MM/YYYY HH:mm") : t("global:serviceconfirmmodal.generate")}</BMXButton>
        </Col>
      </Row>

      <Row>
        <Col className="d-flex align-items-center justify-content-center mt-4">
          <CanvasDraw
            style={{ border: "1px solid #ccc", borderRadius: "4px" }}
            brushRadius={1}
            disabled={Boolean(values?.signature)}
            ref={canvasDrawRef}
            // hideGridX
            // hideGridY
            canvasWidth={800}
            canvasHeight={400}
            lazyRadius={0}
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex align-items-center justify-content-center mt-2">
          {!values?.signature && <BMXButton bmxclass="Secondary" onClick={() => canvasDrawRef.current.clear()}>
            {t('global:serviceconfirmmodal.clearsignature')}
          </BMXButton>}
        </Col>
      </Row>
      {(submitFailed && isSubmit) ?
        <Row>
          <Col className="text-center mt-3" style={{ color: "var(--BMX-error)" }}>
            <span>{t("global:serviceconfirmmodal.errors.data")}</span>
          </Col>
        </Row>
        : null}
    </div >
  );
};

export default ServiceConfirmFormStepOne;
